import React from "react";
import { useTranslation } from 'react-i18next';


const ChangeLog = () => {
    const { t, i18n } = useTranslation();

  return (
      <table class="version-table">
        <tr>
          <th>{t('Version No.')} </th>
          <th>{t('Release Date')}  </th>
          <th>{t('Last Changes Summary')} </th>
        </tr>
        <tr>
          <td>1.0.0</td>
          <td>12-Jan-2024</td>
          <td>
            <ul>
              <li>{t('Customer Search Integrate')} </li>
              <li>{t('Modelstring Breakdown for single tag')}</li>
              <li>{t('New User access request')} </li>
              <li>{t('Flow PA / Call the Configurator after sizing is complete')}</li>
              <li>
              {t('Data Segregation to restrict data from another Business Unit')}   
              </li>
            </ul>
          </td>
        </tr>
      </table>    
  );
};

export default ChangeLog;
